import { type Ref, ref } from 'vue'

export const useCarousel = (max: number, container: Ref<HTMLElement | null> | null = null) => {
  const current = ref(0)
  const lastScrollPosition = ref(0)

  const goBack = () => {
    if (current.value - 1 >= 0) {
      current.value -= 1
    } else {
      current.value = max
    }
  }

  const goForward = () => {
    if (current.value + 1 <= max) {
      current.value += 1
    } else {
      current.value = 0
    }
  }

  const goTo = (index: number) => {
    current.value = index
    slide()
  }

  const slide = () => {
    if (!container?.value) return
    container.value.scrollTo({
      behavior: 'smooth',
      left: container.value.clientWidth * current.value,
    })
  }

  const handleScroll = () => {
    if (!container?.value) return

    current.value =
      lastScrollPosition.value < container.value.scrollLeft
        ? Math.ceil(container.value.scrollLeft / container.value.clientWidth)
        : Math.floor(container.value.scrollLeft / container.value.clientWidth)

    lastScrollPosition.value = container.value.scrollLeft
  }

  return { current, max, goBack, goForward, goTo, handleScroll }
}
